module.exports = __webpack_public_path__ + "img/aio_cover_c.6bf3c459.png";